import {Tailwind} from '@wandb/weave/components/Tailwind';
import * as React from 'react';
import {twMerge} from 'tailwind-merge';

import {type LoadableView} from '../../state/views/types';
import {type WorkspaceError as WorkspaceErrorType} from '../../state/workspaces/types';

export type WorkspaceErrorContentProps = {
  error?: WorkspaceErrorType;
  viewType: LoadableView['type'] | undefined;
};

const FULL_HEIGHT_STYLE = {height: '100%'};

export const WorkspaceError = ({
  children,
  title,
  header,
}: {
  title: string;
  header?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  return (
    <Tailwind style={FULL_HEIGHT_STYLE}>
      <div
        className={twMerge(
          'flex flex-col items-center justify-center',
          'h-full w-full pb-[60px]'
        )}>
        {header}
        <h1 className="text-2xl font-semibold leading-[32px]">{title}</h1>
        {children}
      </div>
    </Tailwind>
  );
};
